var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 15.5218L8.625 12L1.875 12L5.25 15.5218Z",
    fill: "#575656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 5.25C9.39708 5.25 6.375 8.27208 6.375 12H4.125C4.125 7.02944 8.15444 3 13.125 3C18.0956 3 22.125 7.02944 22.125 12C22.125 16.9706 18.0956 21 13.125 21C10.4368 21 8.02277 19.82 6.37529 17.9534L8.06221 16.4645C9.3007 17.8677 11.1091 18.75 13.125 18.75C16.8529 18.75 19.875 15.7279 19.875 12C19.875 8.27208 16.8529 5.25 13.125 5.25Z",
    fill: "#575656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 11.6884V8.625H14.2498V12.3116L12.402 15.3913L10.4727 14.2337L11.9998 11.6884Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreIcon);
export default __webpack_public_path__ + "static/media/restoreIcon.5446872750ff967be29db6448f2d3f1c.svg";
export { ForwardRef as ReactComponent };